
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dorm-moving-storage",
      function () {
        return require("private-next-pages/dorm-moving-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dorm-moving-storage"])
      });
    }
  